import { SxProps, Theme } from '@mui/material';

export const LocateStoreGoBackButtonSX: Record<string, SxProps<Theme>> = {
	link: {
		pb: 1,
		color: 'secondary.main',
		cursor: 'pointer',
	},
};
